import { useEffect, useState, useRef, useCallback } from "react"
import {
  Container, Button, Tabs,
  Tab, Box, Select, FormControl, MenuItem,
  CircularProgress,
  InputLabel, Popover, IconButton,
} from "@mui/material";
import TicketSummery from "../card";
import { Wrapper, NewTicket, FaqButton,
  FiltersRow, FilterBox, Row } from "./style";
import axios from '../../../functions/requestInterceptor'
import CategoryModal from '../selectCategory'
import { useNavigate, useParams } from "react-router-dom"
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SortIcon from '@mui/icons-material/Sort';
import DeleteIcon from '@mui/icons-material/Delete';
import { ticketsStatus } from '../../../functions/ticketsStatus'
import AppBar from "./menu";
import EmptyDashboard from './empty'
import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear'

function CircularIndeterminate() {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  );
}

const page_size = 200
const reminderOptions = Array(30).fill().map((x,i)=> i + 1)

export default function Dashboard () {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'dashboard' });
  const urlParams = useParams()
  const isImpersonateMode = !!urlParams.userId

  const navigate = useNavigate()

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false)
  };

  const [filter, setFilter] = useState(localStorage.getItem('tab') || '');
  const handleChangeFilter = (e, newValue) => {
    setFilter(newValue)
    localStorage.setItem('tab', newValue.toString())
  }

  const [statusFilter, setStatusFilter] = useState(localStorage.getItem('filter') ||'All');
  const handleChangeStatusFilter = (e) => {
    setStatusFilter(e.target.value)
    localStorage.setItem('filter', e.target.value)
  }

  const [reminderFilter, setReminderFilter] = useState(localStorage.getItem('reminderFilter') ?? '');
  const handleChangeReminderFilter = (e) => {
    setReminderFilter(e.target.value)
    setPage(1)
    localStorage.setItem('reminderFilter', e.target.value)
  }

  const [sort, setSort] = useState(localStorage.getItem('sort') || 'newest')
  const handleChangeSort = () => {
    const newSort = sort === 'newest' ? 'oldest' : 'newest'
    setSort(newSort)
    localStorage.setItem('sort', newSort)
  };

  const [search, setSearch] = useState(localStorage.getItem('search') ||'');

  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem('user'))
  const [ticketList, setTicketList] = useState({
    results: [],
    count: 0,
    next: null,
    previous: null
  });

  const [page, setPage] = useState(1)
  const [paginationLoading, setPageLoading] = useState(false)

  const getTickets = () => {
    setPageLoading(true)
    const params = {
      page: page,
      page_size: page_size
    }
    if (user?.type === 'admin') {
      if (filter) {
        if (filter === 'reminder') {
          params.reminder_date_lte = new Date().toISOString()
        } else {
          params.category = filter
        }
      }
      if (statusFilter !== 'All') params.status = statusFilter
      if (!!reminderFilter) {
        if (reminderFilter !== '+30') {
          const days = reminderFilter
          params.in_progress_at_gte = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString()
        } else {
          params.in_progress_at_lte = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString()
        }
      }
      if (isImpersonateMode) params.user = urlParams.userId
      if (search) params.search = search
      params.order = sort
    }

    axios.get('/tickets/list', {
      params: params
    })
      .then((response) => {
        if (page === 1) {
          setTicketList(response.data)
        } else {
          const firstMessages = ticketList.results.filter((item, index) => index < (page - 1) * page_size)
          setTicketList({
            ...response.data,
            results: [...firstMessages, ...response.data.results]
          })
        }
      })
      .catch((error) => {
        if(error?.response?.status === 401) {
          navigate('/login')
        }
      })
      .finally(() => {
        setLoading(false)
        setPageLoading(false)
      })
  }

  const [intervalId, setIntervalId] = useState(null);
  useEffect(() => {
    getTickets()

    const interval = setInterval(() => {
      getTickets()
    }, 5000)
    setIntervalId(interval)

    return () => clearInterval(interval)
  }, [filter, statusFilter, reminderFilter, isImpersonateMode, search, page, sort])

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;

  const [categoriesOptions, setCategoriesOptions] = useState([])
  useEffect( () => {
    const loadCategories = async () => {
      axios.get('/categories/')
       .then((response) => {
         setCategoriesOptions(response.data.results)
       })
       .catch((error) => {
         console.log(error);
       });
    }
    loadCategories()
  }, [])

  const observer = useRef();

  const lastPostElementRef = useCallback(
    (node) => {
      if (paginationLoading) return;

      const hasMore = page * page_size < ticketList.count
      if (!hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prevPage) => prevPage + 1); // trigger loading of new posts by chaging page no
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, paginationLoading]
  );
  
  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  const handleSearch = (text) => {
    setSearch(text)
    localStorage.setItem('search', text)
  }

  if (loading) {
    return <CircularIndeterminate />
  }

  const tabs = [
    ...categoriesOptions,
    {
      id: 'reminder',
      name: 'یادآورها',
      sort: 13
    },
  ]

  return (
    <Container
      maxWidth='xs'
      dir={direction}
      sx={{padding: 0, height: '100%', display: 'flex', flexDirection: 'column', position: 'relative'}}
      onLoad={() => window.history.forward()}
    >
      <AppBar handleSearchUser={(data) => handleSearch(data)} />
      {isImpersonateMode &&
        <Row>
          <span>{`${ticketList.results[0]?.user.first_name} ${ticketList.results[0]?.user.last_name}`}</span>
          {user.type === 'admin' && <IconButton onClick={() => navigate('/')}>
            <ClearIcon fontSize='small'/>
          </IconButton>}
        </Row>
      }
      <Wrapper>
        {user?.type === 'admin' && <>
          <FiltersRow>
            
              <Tabs
                value={filter}
                onChange={handleChangeFilter}
                dir={direction}
                allowScrollButtonsMobile
                scrollButtons='auto'
                variant="scrollable"
              >
                <Tab value='' label={t('all')} />
                {tabs.map(item => (
                  <Tab value={item.id.toString()} label={item.name} key={item.id} />
                ))}
              </Tabs>
              
              <Box sx={{
                display: 'flex',
              }}>
                <FilterAltIcon
                  className="pointer icon"
                  aria-describedby={id}
                  color={statusFilter !== 'All' || reminderFilter !== 'All' ? 'primary' : 'default'}
                  onClick={handleClick} />
                <SortIcon
                  className={`pointer icon ${sort}`}
                  onClick={handleChangeSort} />
              </Box>
          </FiltersRow>
          <Popover
            id={id}
            open={openPopover}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <FilterBox>
              <Box sx={{
                display: 'flex',
                gap: 1,
                alignItems: 'flex-end'
              }}>
                <Box
                  sx={{
                    flexGrow: 1,
                  }}
                >
                  <InputLabel>{t('status')}</InputLabel>
                  <FormControl fullWidth>
                    <Select
                      value={statusFilter}
                      onChange={handleChangeStatusFilter}
                      size='small'
                    >
                      <MenuItem value='All'>
                        {t('all')}
                      </MenuItem>
                      {Object.keys(ticketsStatus).map((item) => (
                      <MenuItem value={item} key={item}>
                        {ticketsStatus[item]}
                      </MenuItem>
                    ))}
                    </Select>
                  </FormControl>
                </Box>
                <Button
                  variant="outlined"
                  style={{height: '40px'}}
                  color="error"
                  onClick={() => {
                    setStatusFilter('All')
                    setReminderFilter('')
                    localStorage.setItem('filter', 'All')
                    localStorage.setItem('reminderFilter', '')
                  }}
                >
                  <DeleteIcon />
                </Button>
              </Box>
              {statusFilter === 'ONGOING' && <Box
                sx={{
                  flexGrow: 1,
                }}
              >
                <InputLabel>
                زمان در انتظار
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    value={reminderFilter}
                    onChange={handleChangeReminderFilter}
                    size='small'
                  >
                    {reminderOptions.map((item) => (
                      <MenuItem value={item.toString()} key={item}>
                        {item}
                      </MenuItem>
                    ))}
                    <MenuItem value='+30'>
                      بیشتر از ۳۰ روز
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>}
            </FilterBox>
          </Popover>
        </>}
        {user?.type !== 'admin' && <NewTicket>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
          >
            {t('create_new_ticket')}
          </Button>
        </NewTicket>}
        {user?.type !== 'admin' && <FaqButton>
          <Button
           variant="contained"
           color="secondary"
           onClick={() => navigate('/faq')}
          >
            {t('help')}
          </Button>
        </FaqButton>}

        {!ticketList.results?.length &&
          <EmptyDashboard
            user={user}
            handleCreateNewMessage={() => setOpen(true)}
          />
        }

        {ticketList.results?.map((ticket, index) => (
          <div ref={ticketList.results.length === index + 1 ? lastPostElementRef : null}>
            <TicketSummery
              key={ticket.id}
              data={ticket}
            />
          </div>
        ))}

      </Wrapper>
      <CategoryModal
        categories={categoriesOptions}
        open={open}
        handleClose={handleClose} />
    </Container>
  )
}
